import { Button } from "@sellar-io/components";
import { PushNotificationDevicesGetResponseType } from "@sellar-io/api-v2/types";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { usePushNotificationDeviceDelete } from "../../../hooks/api/v2/pushNotification/usePushNotificationDeviceDelete";

export const PushNotificationDeviceDeleteModal = ({
  onDismiss,
  device,
  active,
}: {
  onDismiss: () => void;
  device: PushNotificationDevicesGetResponseType[number];
  active: boolean;
}) => {
  const deviceNameDeleteMutation = usePushNotificationDeviceDelete(device.id);

  const deleteDevice = () => {
    deviceNameDeleteMutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
    });
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`Remove push notification permissions for ${device.deviceName}?`}
        description="You will no longer receive push notifications on this device"
      />
      <DialogCTA>
        <Button color="transparent" onClick={() => onDismiss()}>
          Dismiss
        </Button>
        <Button
          color="red"
          onClick={() => deleteDevice()}
          loading={deviceNameDeleteMutation.isPending}
        >
          Delete
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
